import {Mixins} from "../Mixins";

export default class HesapBilgisi {
    id: number | null = null;
    kayitID: string = ""//kayitID;
    bankaAdi: string = ""//bankaAdi;
    ibanNumarasi: string | null = null;//ibanNumarasi;
    iban: string | null = null;
    hesapGenel: string = ""//hesapGenel;
    hesapAktifmi: string = ""//hesapAktifmi;
    isSelected: boolean = true;
    isVekilIban: boolean = false;

    constructor(tarafDomNode: HTMLUnknownElement | Element | null = null) {
        if (tarafDomNode) {
            let ibanNode = tarafDomNode.querySelector('iban');
            if (ibanNode)
                this.ibanNumarasi = Mixins.onlyDigit(ibanNode.getAttribute("no"));
        }

    }

}

